if (!window.CandidateLink) window.CandidateLink = {};
(function() {
  var ajax = new XMLHttpRequest();
  ajax.open("GET", window.location.origin + "/api/system/v1/countries_states.json");
  ajax.onreadystatechange = function() {
    if (ajax.readyState != 4) return;
    window.CandidateLink.countries = JSON.parse(ajax.responseText);
    try {
      reloadStates();
      preselectState();
    } catch (_exception) {
    }
  };
  ajax.send();
  var selectCountry = document.getElementById("application_candidate_attributes_address_attributes_country_id");
  var selectState = document.getElementById("application_candidate_attributes_address_attributes_state_id");
  if (!selectCountry || !selectState) return;
  var reloadStates = function(e) {
    var val = parseInt(selectCountry.value), country = null;
    for (var i in window.CandidateLink.countries) {
      if (window.CandidateLink.countries[i]["id"] == val) {
        country = window.CandidateLink.countries[i];
        break;
      }
    }
    selectState.options.length = 0;
    selectState.add(new Option("Please choose...", ""), null);
    if (!country) return;
    var otherIndex;
    for (var i in country["states"]) {
      if (country["states"][i]["name"] == "Other") {
        otherIndex = i;
        continue;
      }
      var option = new Option(country["states"][i]["name"], country["states"][i]["id"]);
      try {
        selectState.add(option, null);
      } catch (e2) {
        selectState.add(option);
      }
    }
    try {
      var option = new Option(country["states"][otherIndex]["name"], country["states"][otherIndex]["id"]);
      selectState.add(option, null);
    } catch (e2) {
      selectState.add(option);
    }
  };
  var preselectState = function() {
    selectState.value = selectState.dataset.initialId;
  };
  if (selectCountry.addEventListener) {
    selectCountry.addEventListener("change", reloadStates, true);
  } else if (selectCountry.attachEvent) {
    selectCountry.attachEvent("onchange", reloadStates);
  }
})();
